import React, { Component, PropTypes } from 'react'
import Button from './Button'
import withCdnUrl from './withCdnUrl'

export class TriColumn extends Component {
  joinAsEither = () => {
    const url = `https://app.playvs.com/sign-up/`
    window.open(url, '_blank')
  }
  render() {
    return (
      <section className="section--lgrey">
        <div className="container">
          <div className="section__head--noPara">
            <h2>How our League Works</h2>
          </div>
          <div className="section__body">
            <div className="row">
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-coach.gif`} />
                  <div className="meta">
                    <h4>Find a Coach</h4>
                    <p>
                      Schools approve the program and select coaches. IT administrators make sure your tech is ready to go.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-team.gif`} />
                  <div className="meta">
                    <h4>Build a Team</h4>
                    <p>
                      Coaches build multiple teams that all represent the same school. There are no cuts and teams are co-ed.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-compete.gif`} />
                  <div className="meta">
                    <h4>Compete Together</h4>
                    <p>
                      Each team will play on campus and compete with other schools in the state. No travel required.
                    </p>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-trophy.gif`} />
                  <div className="meta">
                    <h4>Win a Championship</h4>
                    <p>
                      Build on your strategies throughout the season to make the playoffs. Go all out to compete in the final championship game.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="section__CTA">
            <Button
              type="button"
              className="btn btn__primary"
              text="Get started"
              onClick={this.joinAsEither}
            />
          </div>
        </div>
      </section>
    )
  }
}

export default withCdnUrl(TriColumn)



// WEBPACK FOOTER //
// ./src/common/ui/components/triColumn.js